import { render, staticRenderFns } from "./AxConfigureWorkspaceSecurity.vue?vue&type=template&id=cbbf7810&scoped=true&"
import script from "./AxConfigureWorkspaceSecurity.vue?vue&type=script&lang=ts&"
export * from "./AxConfigureWorkspaceSecurity.vue?vue&type=script&lang=ts&"
import style0 from "./AxConfigureWorkspaceSecurity.vue?vue&type=style&index=0&id=cbbf7810&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbf7810",
  null
  
)

export default component.exports